import React from "react"
import styles from '../../App.module.scss'

export default function Games() {
    return (
        <>
            <h1 className={styles.title}>Games</h1>
        </>
    )
}